import { render, staticRenderFns } from "./CollectionUserSchedule.vue?vue&type=template&id=1127323a&scoped=true"
import script from "./CollectionUserSchedule.vue?vue&type=script&lang=js"
export * from "./CollectionUserSchedule.vue?vue&type=script&lang=js"
import style0 from "./CollectionUserSchedule.vue?vue&type=style&index=0&id=1127323a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127323a",
  null
  
)

export default component.exports